import {types} from "mobx-state-tree"
import df from 'utils/data_fetch'
import DataNav from 'model/util/data_nav'
import {Endpoints} from 'config/endpoints';

import {translate} from 'i18n/localize'


/*@@
  @Name: Base (ModelType)
  @Description: To be combined with other stores to provide data fetch

  @Usage
     import Base from "model/stores/base"
     ... ...
     const AuditLogStore = types.model({ ...})
     ... ...
     export default types.compose("AuditLogStore", Base, AuditLogStore)
     ...
 */

const Base = types.model('Base',{
  loading: types.optional(types.boolean, true),
  data_nav: types.optional(DataNav, ()=>DataNav.create({}))
})
  .volatile(self => ({
    blob: {},
  }))

  .actions(self => ({
    setBlob(data) {
      self.blob = data
    },

    //by default:
    // -- successCallback is self.loadSuccess
    // -- failCallback is self.loadError
    // no need to pass them for a common load cases
    // for everything else:
    // -- pass successCallback.
    // -- do not pass anything if you want to have an error message back and handle 401 and simialr common cases
    // -- pass an empty failCallback in case nothing at all should happen on failure
    // (example in user_data_store, updateTimePeriod - but this may be rewritten later, depedning on UX decision

    load(
      url = 'same',
      params = {},
      method = 'GET',
      successCallback= null,
      failCallback= null,
      extra_options = {}
    ) {
      const target_url = url === 'same' ? self.service_url : url;
      return df
        .run(target_url, params, method, extra_options)
        .then((response) => self.handleResponse(response, successCallback, failCallback));
    },
    handleResponse(response, successCallback=null, failCallback=null) {
      successCallback = successCallback || self.loadSuccess
      failCallback = failCallback || self.loadError
      if (response.status == 'OK' ) {
        successCallback(response)
      } else {
        failCallback(response, successCallback)
      }
    },

    loadSuccess() {
      console.error("Store must have a 'loadSuccess' action ")
    },
    loadError(response, successCallback){
      successCallback = successCallback || self.loadSuccess
      try {
        if (!!response.status) {
          switch (response.status.toString()) {
            case '401':
              self.logout()
              break;
            case '500':
              console.error('===ERROR===', response)
              response.error_message = translate('error_message_generic')
              successCallback(response)
              break;
            case '408':
            case '504':
            case '599':
              console.error('===ERROR===', response)
              response.user_message = translate('error_message_timeout')
              successCallback(response)
              break;
            default: //regular  errors end everything else. TODO add more later
              //add generic text and pass it back to component to show
              console.error('===ERROR===', response)
              response.error_message = translate('error_message_generic')
              successCallback(response)
          }
        } else {
          //????
          console.error('===ERROR===', response)
          response.user_message = translate('error_message_generic')
        }
      } catch (e) {
        //??? do we need anything
        console.error('Caught something...: ', e)
      } finally {
        console.log( 'End of the error')
      }

    },

    get(params = {}) {
      self.load('same', params, 'GET')
    },

    set_loading(state) {
      self.loading = state
      if (self.loading == false) {
        self.data_nav.showFilters(false)
        self.data_nav.setResetting(false)
      }
    },
    data_fetch() {
      return df
    },
    //Called when a store status is a 401
    logout() {
      window.stop() //stop all other requests to save time
      window.location.assign(Endpoints('SIGN_OUT').href)
    },
    end_loading() {
      self.loading = false
    },
    execute_in_session(url, query_params, method) {
      let def = self.data_fetch().run(url, query_params, method)
      def.then((response) => {
        if (!!response.status && response.status.toString() == '401') {
          self.logout()
        }
      })
      return def
    },
    // Experimental: refreshes the page if a 422 is returned (mostly due to CSRF errors). If the session is valid
    // the page will be refreshed without CSRF errors. If invalid it will be redirected to the sign in page. This
    // prevents unwanted sign outs.
    execute_in_session_or_refresh(url, query_params, method) {
      let def = self.data_fetch().run(url, query_params, method, { refresh_if_422: true })
      def.then((response) => {
        if (!!response.status && response.status.toString() == '401') {
          self.logout()
        }
      })
      return def
    }
  }))


export default Base
